var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckAlertRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BA3D6EAA-0641-4CA9-A9BD-0910F1AAE844") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1424,
    height: 496,
    rx: 10
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.9%",
    y: "-3.0%",
    width: "103.8%",
    height: "110.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.04 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consultant",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timesheet-Copy-4",
    transform: "translate(-395.000000, -1678.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F8F8FA",
    x: 0,
    y: 0,
    width: 1680,
    height: 2039
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(156.000000, 1466.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "x-red",
    transform: "translate(239.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#BF0000",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95205177,4.04794823 C10.2724037,4.36830019 10.2924257,4.87525326 10.0121178,5.21893036 L9.95205177,5.2853851 L8.23666667,6.99966667 L9.95205177,8.7146149 L10.0121178,8.78106964 C10.2924257,9.12474674 10.2724037,9.63169981 9.95205177,9.95205177 C9.61034301,10.2937605 9.05632366,10.2937605 8.7146149,9.95205177 L6.99966667,8.23666667 L5.2853851,9.95205177 C4.94367634,10.2937605 4.38965699,10.2937605 4.04794823,9.95205177 C3.72759628,9.63169981 3.70757428,9.12474674 3.98788224,8.78106964 L4.04794823,8.7146149 L5.76166667,6.99966667 L4.04794823,5.2853851 L3.98788224,5.21893036 C3.70757428,4.87525326 3.72759628,4.36830019 4.04794823,4.04794823 C4.38965699,3.70623948 4.94367634,3.70623948 5.2853851,4.04794823 L6.99966667,5.76166667 L8.7146149,4.04794823 C9.05632366,3.70623948 9.61034301,3.70623948 9.95205177,4.04794823 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAlertRed);
export default __webpack_public_path__ + "static/media/check-alert-red.886b4b5a1caa7c4f05f3e473ca8adfdb.svg";
export { ForwardRef as ReactComponent };